module.exports = __webpack_public_path__ + "img/Staffan.b43784b6.jpg";